import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/proofOfResidence');

export default function PEPHint() {
  return <Content />;
}
